import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import AnimationComp from '../animation-comp/AnimationComp.component';
import './DashboardEventItem.styles.css';

const DashboardEventItem = ({isEmpty, data, t}) => {

    if(isEmpty) {
        return(
            <div className='cm-dash-event-item cm-dash-event-empty-item py-3 border border-blue-gray-100 px-32 col-4'>
                <h3 className='h3 mb-1 cm-gradient-txt lh-base'>{t('nothing_to_see')}</h3>
                <div className="cm-empty-dash-event-footer d-flex align-items-center text-blue-gray-700">
                    <FontAwesomeIcon icon={regular('face-smile')} className="text-blue-gray-700" />
                    <p className='text-blue-gray-700 my-0 ms-2'>{t('no_events_available')}</p>
                </div>
            </div>
        )
    } else {
        return (<div className={`cm-dash-event-item bg-white py-3 border border-blue-gray-100 ${data.widthFactor !== '4' ? 'col col-xxl' : 'col'}-${data.widthFactor}`}>
                <h3 className="h4 cm-gradient-txt mb-2 cm-mmc-font">{data.title}</h3>
                <div className="cm-dash-event-item-footer text-blue-gray-700 d-flex align-items-center">
                    {data.iconClass ?  <FontAwesomeIcon icon={data.iconClass} className="pe-2" /> : <div className='pe-1'><AnimationComp animationData={data.animation.data} width={data.animation.width} height={data.animation.height} /></div>}
                    <span className="fw-medium cm-sm-txt">{data.subTitle}</span>
                    {
                        !!data.eventLink ?
                        <>
                            <div className="cm-de-event-hr my-0 bg-blue-gray-300" />
                            <Link to={data.eventLink} className="text-action-blue cm-sm-txt">
                                {t('view_event')}
                                <FontAwesomeIcon icon={regular('angle-right')} className="ps-2" />
                            </Link>
                        </>
                        : null
                    }
                </div>
            </div>)
    }
}


DashboardEventItem.defaultProps = {
    isEmpty: false,
}

export default DashboardEventItem;